import { createCtx } from 'utils/create-ctx';
import { UserPayload } from 'types/user-payload';

const [ctx, UserProvider] = createCtx<UserPayload | null>(null);

export { ctx as userContext, UserProvider };
